import {
  type PermissaoEmpresa,
  type PermissaoPlataforma,
  type UsuarioAtual,
  type VinculoResumo,
} from '@fiscoai/contracts';

/** Regras puras de "pode ou não" — a interface só esconde; quem barra de verdade é o server. */

export function podeNaPlataforma(usuario: UsuarioAtual, permissao: PermissaoPlataforma): boolean {
  return usuario.permissoesPlataforma.includes(permissao);
}

export function podeNaEmpresa(
  usuario: UsuarioAtual,
  empresaId: string,
  permissao: PermissaoEmpresa,
): boolean {
  return usuario.vinculos.some(
    (v) => v.empresa.id === empresaId && v.permissoes.includes(permissao),
  );
}

/** Empresas em que a pessoa tem a permissão (ex.: onde pode importar). */
export function empresasCom(usuario: UsuarioAtual, permissao: PermissaoEmpresa): VinculoResumo[] {
  return usuario.vinculos.filter((v) => v.permissoes.includes(permissao));
}

export function podeEmAlguma(usuario: UsuarioAtual, permissao: PermissaoEmpresa): boolean {
  return empresasCom(usuario, permissao).length > 0;
}
